// extracted by mini-css-extract-plugin
module.exports = {"results":"SearchUsers_results__2NjyN","result":"SearchUsers_result__1sGtE","resultItem":"SearchUsers_resultItem__Nyli5"};